<template>
    <div
        ref="container"
        v-intersect="getOffsets"
        class="d-flex justify-content-start overflow-x-scroll hidden-overflow-scrollbar"
        style="scroll-snap-type: x mandatory;"
        @scroll.passive="handleScroll">
        <img
            v-for="(image, key) in computedImages"
            ref="imageRefs"
            :key="key"
            loading="lazy"
            :alt="image.caption"
            :src="image.link"
            style="aspect-ratio: 1 / 1; object-fit: cover; scroll-snap-align: start;"
            :style="{ width: width ? '' + width + 'px' : '0' }">
    </div>
    <template v-if="computedImages.length > 1">
        <teleport v-if="parent" :to="parent">
            <div class="position-absolute d-flex gap-8 align-items-center" style="bottom: 1rem; left: calc(50% - 24px)">
                <div
                    v-for="(image, key) in computedImages"
                    :key="key"
                    style="width: 8px; height: 8px; border-radius: 4px;"
                    :style="{ background: image.id === focused ? '#FFFFFF' : '#B8B4C9'}"/>
            </div>
        </teleport>
    </template>
</template>
<script setup lang="ts">
import {computed, ref} from 'vue';
import {Image} from '../../types';
import {cloudFileNameFormatted} from '../../models/utilities/ModelUtilities';

const props = defineProps<{
    images?: Image[],
    parent?: unknown,
    width?: number,
}>();

const imageRefs = ref<HTMLImageElement[]>([]);
const container = ref<HTMLDivElement>(null);
const offsets = ref([]);
const focused = ref(props.images ? props.images[0].id : 0);

const computedImages = computed(() => {
    if (!props.images) {
        return [];
    }
    return props.images
        .map(v => {
            return {
                id: v.id,
                link: cloudFileNameFormatted(v.cloudFileName),
                caption: v.caption,
                primaryImage: v.primaryImage,
            };
        })
        .sort((a, b) => b.primaryImage - a.primaryImage);
});

const getOffsets = () => {
    if(!props.images || !props.images.length) { return; }
    offsets.value = imageRefs.value.map(v => v.offsetLeft);
};

const handleScroll = () => {
    if(!offsets.value) { return; }
    for (let i = 0; i < offsets.value.length; i++) {
        if (offsets.value[i] <= container.value.scrollLeft && container.value.scrollLeft < offsets.value[i] + offsets.value[1]) {
            focused.value = i;
            break;
        }
    }
};
</script>
